import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from 'libs/auth-lib/src/public-api';

import { AuthorizationSessionService } from '../../services/authorization-session.service';

@Component({
  template: '',
  standalone: false,
})
export class LogoutPage implements OnInit {
  constructor(
    private authService: AuthService,
    private authorizationSessionService: AuthorizationSessionService,
    private router: Router
  ) {}

  /**
   * Effacer le jeton du navigateur ne déconnecte de rien depuis que le serveur d'autorisation tient
   * une session : elle redélivrerait un code à la première autorisation suivante, donc reconnecterait
   * silencieusement le précédent utilisateur — sur un poste partagé, c'est une reprise de compte.
   *
   * L'effacement local passe en premier parce qu'il ne peut pas échouer. La fermeture serveur suit,
   * en meilleur effort : `close()` ne lève jamais, donc la navigation a lieu dans tous les cas.
   */
  ngOnInit(): void {
    this.authService.eraseStoredToken();
    this.authorizationSessionService.close().subscribe(() => {
      this.router.navigate(['login'], { queryParamsHandling: 'preserve' });
    });
  }
}
